import { Component, input, Input } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { NgbActiveModal, NgbDatepicker, NgbModal, NgbModalOptions, NgbModule, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../Util/Toast/toast.service';
import { AdditionOfManpowerService } from '../../Model/AdditionReductionOfManpower/addition-of-manpower.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { Subject } from 'rxjs';
import { DataTablesModule } from 'angular-datatables';
import { DesignationWiseDetailSummaryComponent } from '../designation-wise-detail-summary/designation-wise-detail-summary.component';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { CommonService } from '../../Model/Common/common.service';

@Component({
  selector: 'app-designation-wise-summary',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, NgbDatepicker, DataTablesModule, LoaderComponent],
  templateUrl: './designation-wise-summary.component.html',
  styleUrl: './designation-wise-summary.component.scss'
})
export class DesignationWiseSummaryComponent {
  @Input() InputData: any;
  @Input() edit: boolean = true;
  isDisabled: boolean = false
  Data: any[] = [];
  allowFutureDate = false;
  selectedDate = null;


  TotalCount = 0;
  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private siteadditionreduction: AdditionOfManpowerService,
    private download: DownloadSampleService,
    protected common: CommonService,
  ) {
    this.common.getPageRights();
  }

  ngOnInit(): void {
    console.log(this.InputData);
    this.selectedDate = this.InputData.AsOnDate;
    this.ESS_SiteManpowerSummary();
  }

  DesignationWiseDetails(element: any) {
    if (this.common.PageRight.IsView) {
      const modalRef = this.modalService.open(DesignationWiseDetailSummaryComponent, { centered: true, backdrop: 'static', size: 'xl' });
      modalRef.componentInstance.InputData = {
        SelectType: 'DW',
        ESS_ShiftWiseManpowerMasterId: '',
        ESS_ShiftWiseManpowerDetailsId: '',
        AllocationType: '',
        WoNo: '',
        SiteId: element.SiteMasterId,
        DesignationId: element.DesignationMasterID,
        DutyId: element.DutyMasterID,
        ShiftId: element.ShiftMasterID,
        AsOnDate: this.InputData.AsOnDate,
        DutyName: element.DutyName,
        Designation: element.DesignationName,
        Shift: element.ShiftTitle,
        Branch: element.BranchName,
        Client: element.ClientGroupName,
        Site: element.SiteName,
      };
      modalRef.componentInstance.DesignationModal = this.activeModal;
      // this.activeModal.close();    
    }
  }

  Cancel() {
    this.activeModal.close();
  }

  ESS_SiteManpowerSummary() {
    this.isDisabled = true;
    this.Data = [];
    if(this.allowFutureDate){
      this.InputData.AsOnDate = null;
    }else{
      this.InputData.AsOnDate = this.selectedDate;
    }
    this.siteadditionreduction.ESS_SiteManpowerSummary(this.InputData).subscribe({
      next: (response) => {
        this.Data = Object.values(response.Table)
        this.TotalCount = response.Table.reduce((total: any, element: any) => {
          return total + parseInt(element.NoOfPerson);
        }, 0);
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  exportToExcel() {
    this.download.exportToExcel(this.Data, "DesignationWiseData");
  }
}

